import animate from '@play-co/timestep-core/lib/animate';
import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import { downscale } from 'src/conf/scale';

/**
 * Show animated tutorial arrow
 */
export class TutorialArrow extends View {
  private img: ImageView;

  constructor(opts: ViewOpts) {
    super({
      centerAnchor: true,
      visible: false,
      opacity: 0,
      scale: 0,
      zIndex: 9000,
      canHandleEvents: false,
      blockEvents: true,
      ...opts,
    });

    const width = downscale(116);
    const height = downscale(161);

    this.img = new ImageView({
      superview: this,
      width,
      height,
      image: 'assets/tutorial/other/tutorial_arrow.png',
      centerOnOrigin: true,
      anchorX: width * 0.5,
      anchorY: height,
    });
  }

  /**
   * Animation loop
   */
  private update() {
    animate(this.img)
      .now({ x: 0, y: 0 }, 500, animate.easeOut)
      .then({ x: 0, y: 30 }, 500, animate.easeIn)
      .then(() => this.update());
  }

  /**
   * Show arrow
   */
  public async fadeIn() {
    animate(this.img).clear();

    this.img.updateOpts({ x: 0, y: 30 });
    this.updateOpts({
      centerOnOrigin: false,
      visible: true,
    });

    this.update();

    return animate(this)
      .clear()
      .then({ opacity: 1, scale: 1 }, 300, animate.easeOut)
      .toPromise();
  }

  /**
   * Hide arrow
   */
  public async fadeOut() {
    await animate(this).clear().toPromise();
    await animate(this.img).clear().toPromise();
    this.updateOpts({ visible: false, opacity: 0, scale: 0 });
  }
}
